/**
 * Format number like 1,000,000.xx, the number of x is determined by param
 */
function formatNum(value: number | string = 0, digits: number = 2): string {
  const num = +value || 0;
  const d = digits > 0 ? digits : 0;

  return num
    .toFixed(d)
    .replace(
      d === 0 ? /(\d)(?=(?:\d\d\d)+$)/g : /(\d)(?=(\d\d\d)+([^\d]))/g,
      "$1,"
    )
    .replace("-", "−");
}

export default formatNum;
